import request from '@/utils/request'

// ==================== 讨论话题相关接口 ====================

// 分页获取话题列表
export function listTopics(params) {
  const courseId = params.courseId || params.course_id
  return request({
    url: `/discussion/topic/byCourse/${courseId}`,
    method: 'get'
  })
}

// 获取话题详情
export function getTopicDetail(topicId) {
  return request({
    url: `/discussion/topic/${topicId}`,
    method: 'get'
  })
}

// 创建话题（老师）
export function createTopic(data) {
  return request({
    url: '/discussion/topic',
    method: 'post',
    data
  })
}

// 更新话题（老师）
export function updateTopic(topicId, data) {
  return request({
    url: `/discussion/topic/${topicId}`,
    method: 'put',
    data
  })
}

// 删除话题（老师）
export function deleteTopic(topicId) {
  return request({
    url: `/discussion/topic/${topicId}`,
    method: 'delete'
  })
}

// 置顶/取消置顶话题（老师）
export function pinTopic(topicId, isPinned) {
  return request({
    url: `/discussion/topic/${topicId}/pin`,
    method: 'put',
    data: { isPinned }
  })
}

// ==================== 评论相关接口 ====================

// 获取话题的评论列表
export function listComments(params) {
  const topicId = params.topicId || params.topic_id
  return request({
    url: `/discussion/reply/byTopic/${topicId}`,
    method: 'get'
  })
}

// 发表评论
export function createComment(data) {
  return request({
    url: '/discussion/reply',
    method: 'post',
    data
  })
}

// 删除评论
export function deleteComment(commentId) {
  return request({
    url: `/discussion/reply/${commentId}`,
    method: 'delete'
  })
}

// ==================== 点赞相关接口 ====================

// 点赞/取消点赞话题
export function likeTopicToggle(topicId) {
  return request({
    url: `/discussion/topic/${topicId}/like`,
    method: 'post'
  })
}

// 点赞/取消点赞评论
export function likeCommentToggle(commentId) {
  return request({
    url: `/discussion/reply/${commentId}/like`,
    method: 'post'
  })
}

// 获取用户的点赞状态（批量）
export function getUserLikeStatus(params) {
  return request({
    url: '/discussion/likes/status',
    method: 'get',
    params
  })
}
